<template>
  <div class="auth-page auth-page--sign_up">
    <div class="auth-page__inner">
      <div class="auth-page__title">{{ $t("registration.title") }}</div>
      <div class="auth-page__sub-title">
        {{ $t("registration.sub_title") }}
      </div>
      <div class="auth-page__fields">
        <div class="auth-page__field">
          <text-input
            :title="$t('registration.full_name.title')"
            :placeholder="$t('registration.full_name.placeholder')"
            v-model="fullName"
            :errors="v$.fullName.$errors"
          ></text-input>
        </div>

        <div class="auth-page__field">
          <text-input
            :title="$t('registration.notary_phone')"
            :mask="'+38 (###) ###-##-##'"
            :errors="v$.phone.$errors"
            v-model="phone"
          ></text-input>
        </div>
      </div>
      <div class="auth-page__agreed">
        <checkbox-input
          v-model="isAgree"
          :errors="v$.isAgree.$errors"
          :text="$t('registration.agreed')"
        ></checkbox-input>
      </div>
      <div class="auth-page__actions">
        <primary-button
          class="auth-page__action auth-page__action"
          :text="$t('registration.sign_up.btn')"
          @click="signUp"
        ></primary-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TextInput from "@/components/inputs/TextInput";
import CheckboxInput from "@/components/inputs/CheckboxInput";
import { RegistrationApi } from "@/office/auth/registration-api";
import { LOGIN_USER, SET_OTP_OPERATION_ID } from "@/store/action-types";

import useVuelidate from "@vuelidate/core";
import { required, minLength, helpers } from "@vuelidate/validators";

const checked = (value) => value === true;

export default {
  name: "SignUp",
  components: { CheckboxInput, TextInput, PrimaryButton },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      phone: "+380",
      fullName: "",
      registryIdentifier: "",
      isAgree: false,
      vuelidateExternalResults: {
        phone: "",
      },
    };
  },
  validations() {
    return {
      phone: {
        required: helpers.withMessage("phone_required", required),
        minLength: helpers.withMessage("phone_incorrect", minLength(19)),
      },
      fullName: {
        required: helpers.withMessage("full_name_required", required),
      },
      isAgree: {
        checked: helpers.withMessage("is_agree_checked", checked),
      },
    };
  },
  methods: {
    async signUp() {
      const isValid = await this.v$.$validate();

      if (!isValid) {
        return;
      }

      new RegistrationApi()
        .signUp({
          fullName: this.fullName,
          phone: this.phone,
          isAgree: this.isAgree,
        })
        .then(async (r) => {
          await this.$store.dispatch(LOGIN_USER, {
            accessToken: r.data.access_token,
            phone: this.phone,
          });
          await this.$store.dispatch(SET_OTP_OPERATION_ID, r.data.operation_id);
          this.$router.push("/sign-up/otp");
        })
        .catch((err) => {
          Object.assign(this.vuelidateExternalResults, {
            phone: err.data.message,
          });

          setTimeout(() => {
            this.v$.$clearExternalResults();
          }, 3000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
  }

  &__action {
    width: 100%;
  }

  &__agreed {
    margin-top: 30px;
  }
}
</style>
